import styled from 'styled-components';

export const TreePanelContent = styled.div`
	padding: 0.75rem 1rem;
	display: flex;
	gap: 10px;
	flex-direction: column;

	@media (max-width: 980px){
		flex-direction: row;
	}
`;

export const TreeFieldGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 0.875rem;
	width: 100%;
	background: var(--cardBgColor);
	border: 1px solid var(--cardBorderColor);
	border-radius: 4px;
	.side-panel--bottom &.tree-field-group--grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;

		@media (max-width: 980px){
			display: flex;
			flex-direction: column;
		}
	}
`;

export const ShapeToggleRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 14px;
	width: 100%;
	.side-panel--bottom & {
		grid-column: 1 / -1;
	}
`;

export const ShapeToggleBtn = styled.button<{ $active?: boolean }>`
	width: 34px;
	height: 30px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 2px;
	border: 1px solid ${({ $active }) => ($active ? 'var(--primary)' : 'var(--cardBorderColor)')};
	background: ${({ $active }) => ($active ? 'var(--selectedBgColor)' : 'var(--chipBgColor)')};
	color: var(--textColor);
	cursor: pointer;

	&:hover{
		border-color: var(--primary);
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
		pointer-events: all;
	}

	svg{
		display: block;
	}
`;

export const ShapeToggleLabel = styled.span`
	font-size: .85rem;
	line-height: 1;
	font-family: 'Inter';
	font-weight: 500;
	color: var(--textColor);
`;

export const ShapeToggleGroup = styled.div`
	display: inline-flex;
	gap: 6px;
	width: 114px;
	@media (max-width: 980px){
		width: auto;
	}
`;

export const ToggleDivWrap = styled.div`
	padding: 1px 10px 1px 9px;
	min-height: 27px;
	border-left: 1px solid var(--borderLightColor); 
	border-right: 1px solid var(--borderLightColor); 
	margin-right: 4px; 
	display: flex;
	align-items:center;
	&.flatten-area{
			padding-left: 10px;
			border-right: none;
	}
	&.delete-area, &.flatten-area{
		.switchButton{
			gap:8px;
		}
	
	}
`;

export const TreeEditModeToggle = styled.div`
	--index: 0;
	position: relative;
	display: inline-grid;
	grid-template-columns: repeat(2, 1fr);
	align-items: center;
	height: 30px;
	border: 1px solid var(--borderLightColor);
	background: var(--surfaceColor);
	border-radius: 999px;
	padding: 2px;
	margin-right: 6px;
	min-width: 140px;
	box-shadow: 0 2px 10px rgba(17, 24, 39, 0.08);

	.slider {
		position: absolute;
		top: 2px;
		bottom: 2px;
		left: calc(2px + (var(--index) * (100% - 4px) / 2));
		width: calc((100% - 4px) / 2);
		background: linear-gradient(180deg, #1e5bff 0%, #003cff 100%);
		border-radius: 999px;
		transition: left 160ms ease;
		z-index: 1;
		box-shadow: 0 1px 2px rgba(17, 24, 39, 0.18);
	}

	.seg-control {
		position: relative;
		z-index: 2;
		height: 100%;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 0 6px;
		cursor: pointer;
		user-select: none;
		white-space: nowrap;
		font-family: Inter;
		font-size: 12px;
		font-weight: 600;
		color: var(--textTitleColor);
		transition: color 160ms ease;

		&::not(:first-of-type)::before {
			content: '';
			position: absolute;
			left: 0;
			top: 6px;
			bottom: 6px;
			width: 1px;
			background: rgba(17, 24, 39, 0.12);
			z-index: 0;
		}
		&:not([data-disabled='true']):hover .seg-label {
			color: #fff;
		}	
		&[data-disabled='true'] {
			opacity: 0.65;
			cursor: not-allowed;

			 .seg-label {
					color: #9AA3A8;
			  }
		}	
		&:not([data-disabled='true'])::after {
				content: '';
				position: absolute;
				inset: 2px;
				border-radius: 999px;
				background: rgba(0, 60, 255, 0.08);
				opacity: 0;
				transition: opacity 120ms ease;
				z-index: 1;
			}	
		&:not([data-disabled='true']):hover::after {
			opacity: 1;
		}	
		&:active {
			transform: scale(0.995);
		}	
		&:not([data-disabled='true']):not(:has(input:checked)):hover .seg-label {
			color: var(--labelValueColor);
		}
			
		input {
			position: absolute;
			opacity: 0;
			pointer-events: none;

			&:checked + .seg-label {
				color: #fff;

				&:hover {
					color: #fff;
				}
			}
		}

		.seg-label {
			position: relative;
			z-index: 2;
		}
			@media (max-width: 540px) {
			&.tree-flatten-control{
				min-width: auto;
			}
				min-width: 200px;
			}
	}

	// .seg-control:not(:first-of-type)::before {
	// 	content: '';
	// 	position: absolute;
	// 	left: 0;
	// 	top: 6px;
	// 	bottom: 6px;
	// 	width: 1px;
	// 	background: rgba(17, 24, 39, 0.12);
	// 	z-index: 0;
	// }

	// .seg-control:not([data-disabled='true']):hover .seg-label {
	// 	color: #28373E;
	// }

	// .seg-control[data-disabled='true'] {
	// 	opacity: 1;
	// 	cursor: not-allowed;
	// }

	// .seg-control[data-disabled='true'] .seg-label {
	// 	color: #9AA3A8;
	// }

	// .seg-control input {
	// 	position: absolute;
	// 	opacity: 0;
	// 	pointer-events: none;
	// }

	// .seg-control input:checked + .seg-label {
	// 	color: #fff;
	// }

	// .seg-control input:checked + .seg-label:hover {
	// 	color: #fff;
	// }

	// .seg-label {
	// 	position: relative;
	// 	z-index: 2;
	// }

	// @media (max-width: 540px) {
	// 	min-width: 250px;
	// }
`;
export const FieldWrapper = styled.div`
	display: flex;
	gap: 14px;
	justify-content:space-between;
	align-items:center;
`;
export const TreeFieldItem = styled.div`
	margin-top: 0;
`;

export const TreewithFlatten = styled.div`
position: relative;
`;

export const TreePreviewWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 260px;
	background: var(--cardBgColor);
	border: 1px solid var(--cardBorderColor);
	border-radius: 4px;
	margin-bottom: 12px;
	@media (max-width: 980px) {
	margin-bottom: 0px;
	}

`;

export const TreePreviewSvg = styled.svg`
	width: 260px;
	height: 260px;
	display: block;
`;